import React from 'react';
import { connect } from 'react-redux';
import { Button, Glyphicon } from 'react-bootstrap';
import { FormControl } from '@/component/form/FormControls.jsx';
import { search, clearSearch } from '../store/globalsearch.store';
import { push } from 'react-router-redux';

export const GLOBAL_SEARCH_URL = '/search/global';

class GlobalSearchFieldClass extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.search = this.search.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.state = { value: '' };
  }
  onChange(e) {
    this.setState({ value: e.target.value });
  }
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.search();
    }
  }
  search() {
    if (this.state.value) {
      this.props.search(this.state.value.trim());
    } else {
      this.props.clearSearch();
    }
  }
  render() {
    return (
      <div style={{ display: 'flex' }}>
        <FormControl
          name="searchText" type="text" id="searchText" placeholder="Global Search..."
          onChange={this.onChange} value={this.state.value}
          onKeyPress={this.handleKeyPress}
        />
        <Button bsStyle="link" className="search-button" onClick={this.search}>
          <Glyphicon glyph="search" />
        </Button>
      </div>
    );
  }
}
GlobalSearchFieldClass.propTypes = {
  search: React.PropTypes.func,
  clearSearch: React.PropTypes.func,
};
export default connect(() => ({}),
  dispatch => ({
    search(text) {
      search(dispatch, text);
      dispatch(push(GLOBAL_SEARCH_URL));
    },
    clearSearch() {
      clearSearch(dispatch);
    },
  }))(GlobalSearchFieldClass);
